import React, { useContext, useEffect, useState } from "react";
import "../App.css";
import { headers } from "../Layout/Layout";
import { ISortingValues } from "../exports/interfaces";
import axios from "axios";
import { toast } from "react-toastify";
import { StartingIndexContext } from "../Context/AllContext";
import useIsMobile from "./MobileQuery";

const GridAlphabetScroll: React.FC = () => {
  const {setStartingIndex } = useContext(StartingIndexContext);

  const [sortingValues, setSortingValues] = useState<ISortingValues[]>();

  const getGridSortingValues = () => { 
    axios
      .get(
        `${process.env.REACT_APP_STRAPIURL}/api/entries?fields[0]=sorting_value&sort[0]=sorting_value:asc&pagination[pageSize]=99999`,
        {
          headers: headers,
        }
      )
      .then((res) => {
        setSortingValues(res.data.data);
      })
      .catch(() => {
        toast.error("Failed to fetch data", {
          position: "bottom-left",
        });
      });
  };

  useEffect(() => {
    getGridSortingValues();
  }, []);

  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const [activeLetter, setActiveLetter] = useState<string | null>(null);

  const handleLetter = (letter: string) => {
    
    setActiveLetter(letter);
    setStartingIndex(
      sortingValues &&
        sortingValues?.findIndex((item) =>
          item.attributes.sorting_value.startsWith(letter.toLowerCase())
        ) + 1
    );
  };

  const mobile = useIsMobile();

  return (
    <div className="alpha">
      {letters.map((letter, index) => (
        <span
          key={index}
          className={`letter${activeLetter === letter ? " active" : ""}`}
          onClick={() => handleLetter(letter)}
          style={{ paddingBottom: mobile ? "2px" : "5px" }}
        >
          {letter}
        </span>
      ))}
    </div>
  );
};

export default GridAlphabetScroll;
